module.exports = __webpack_public_path__ + "img/5-rectangle-6-copy-2@2x.b1cdeccb.png";